var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "25px",
    viewBox: "0 0 113 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smile@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "(WIP)-High-Fidelity-Screens-&-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0---desktop---claim_artist",
    transform: "translate(-742.000000, -506.000000)",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(566.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(176.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7088583,3.43148933 C91.6318949,4.19073832 91.8176887,5.32993935 93.0247078,5.12096573 C96.9609739,4.62702808 105.762475,3.56381745 107.341082,5.59590578 C108.919688,7.62733902 105.595261,16.0570336 104.110192,19.8172486 C103.664286,20.9557946 104.629774,21.411737 105.632419,20.5575 C112.206317,14.8608398 113.914339,3.2225157 112.577264,1.57037942 C111.240189,-0.0811017811 99.7280203,-1.58125725 92.7088583,3.43148933",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.284068,8.22613373 C86.7775376,13.8783492 72.2909814,16.8232878 57.6493782,16.8923905 C38.0624224,16.9382437 18.8004192,11.8872865 1.7575259,2.23680031 C0.371793507,1.43146294 -0.657976855,2.8542041 0.502937412,3.90236974 C15.8571107,17.6195836 35.765143,25.1382185 56.3573201,24.9980756 C71.7857867,24.9980756 89.7234303,20.1679888 102.081967,11.0903448 C104.141507,9.59268856 102.381078,7.34652707 100.284068,8.22613373",
    id: "Fill-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.68826dfdaf5d13cc3679d1f9d150aff7.svg";
export { ForwardRef as ReactComponent };